import React, { PropsWithChildren } from "react";
import { Box, ToggleButtonProps, Tooltip, Typography } from "@mui/material";
import classNames from "classnames";

import { ToggleButton } from "./toolbar.styles";

interface IProps {
  title: string;
  subtitle?: string;
  tooltip?: string;
  hasOptions?: boolean;
  variant?: "minimal" | "full";
}

const ToolbarToggleButton: React.FC<PropsWithChildren<IProps & ToggleButtonProps>> = ({
  title,
  subtitle,
  tooltip = title,
  hasOptions,
  variant = "minimal",
  children,
  ...props
}) => {
  const button = (
    <ToggleButton
      {...props}
      className={classNames(props.className, {
        "has-options": hasOptions,
        "variant-full": variant === "full",
      })}
    >
      {variant === "minimal" ? (
        children
      ) : (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{children}</Box>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", minWidth: 0 }}>
            <Typography variant="body3" sx={{ fontWeight: 500, lineHeight: 1.4, display: "block" }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography sx={{ fontSize: 11, lineHeight: 1.4, color: (theme) => theme.palette.biarri.secondary.grey }}>{subtitle}</Typography>
            )}
          </Box>
        </Box>
      )}
    </ToggleButton>
  );

  return variant === "minimal" ? (
    <Tooltip title={tooltip} placement="right">
      <Box component="span">{button}</Box>
    </Tooltip>
  ) : (
    <Box component="span">{button}</Box>
  );
};

export default ToolbarToggleButton;
